const messages = {
  en: require('./english')
}

module.exports = messages



//////////////////
// WEBPACK FOOTER
// ../Lang/lang/index.js
// module id = Qvz8
// module chunks = 17